import Logo from 'assets/icons/Logo';
import Loading from 'components/common/Loading';
import { Navigate } from 'react-router-dom';
import { t } from 'services/i18n.service';
import { useAppSelectorShallow } from 'store/hooks';
import { routeManagerSelector } from 'store/reducer/selectors/navigation-routes.selector';
import ProtectedRoutesWrapper from './ProtectedRoutesWrapper';
import { ROUTES } from 'constants/routes';
import { isDesktopLoginRequest } from 'services/auth.service';
import DesktopRedirect from 'pages/auth/desktop/DesktopRedirect';
import { isCurrentPath } from 'utils/routes.util';

const ProtectedRoutes = ({
  authenticating,
  isAuthenticated
}: {
  authenticating: boolean;
  isAuthenticated: boolean;
}) => {
  const { isUserLoggingOut } = useAppSelectorShallow(routeManagerSelector);
  if (authenticating || isUserLoggingOut) {
    return (
      <Loading
        icon={<Logo className='~w-[16rem]/[30rem] h-fit' />}
        title={t(
          authenticating ? 'auth_page.authenticating' : 'auth_page.logging_out'
        )}
      />
    );
  } else if (isAuthenticated) {
    return isDesktopLoginRequest && !isCurrentPath(ROUTES.ONBOARD_FLOW) ? (
      <DesktopRedirect />
    ) : (
      <ProtectedRoutesWrapper />
    );
  } else {
    return <Navigate to={ROUTES.LOGIN} />;
  }
};

export default ProtectedRoutes;
